export const mutations = {
  setEmployee: function (state, emp) {
    state.employees = emp;
  },

  setEmployeeLevel: function (state, level) {
    state.emp_level = level;
  },

  setEmployeeDetail: function (state, emp) {
    state.employeeDetail = emp;
  },
  setEmployeeMenu: function (state, emp) {
    state.employeeMenu = emp;
  },
  setDepartment: function (state, dep) {
    state.departments = dep;
  },
  updateEmployee: function (state, emp) {},

  removeEmployee: function (state, emp) {
    var index = [...state.employees].findIndex((e) => e.emp_id == emp.emp_id);
    if (index > -1) {
      state.employees.splice(index, 1);
    }
  },
};
